// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"789358d7","455":"749836d8"}[chunkId] + ".chunk.js";
};